<div class="finalisation--content">
    <div class="simulation__group grid-11 centered finalisation__stepDescription">
        <p class="finalisation__description">
            {{ 'finalisation.signature.description.ecretement' | i18n }}
        </p>
    </div>
    <div class="grid-mobile-4 centered">
        <p>
            {{ 'finalisation.ecretement.steps.description' | i18n }}
        </p>
        <div>
            <div class="signature-steps">
                <div class="signature-steps--item">
                    <span class="signature-steps--element signature-steps--elementImage">
                        <div class="signature-steps--circle">
                            <img class="signature-steps--image" alt="" [appAssetSrc]="'assets/images/signature-step1.svg'" />
                        </div>
                    </span>
                    <span class="signature-steps--element signature-steps--elementText signature-steps--element-padding">
                        <div class="signature-steps--content" data-number="1">
                            <span class="signature-steps--text">
                                {{ 'finalisation.content2.ecretement.step1' | i18n }}
                                <span> </span>
                                <a id="download-signature-id" target="_blank" class="signature-steps--link" (click)="downloadPropositionAssurance()" [appTagCommander]="'tagCo.finalisation.signature-toggle.filedownload'">
                                    <span>{{ 'finalisation.signature.steps.step2.download.link' | i18n }}</span>
                                </a>
                            </span>
                        </div>
                    </span>
                </div>

                <div class="signature-steps--item">
                    <span class="signature-steps--element signature-steps--elementImage">
                        <div class="signature-steps--circle">
                            <img class="signature-steps--image ng-isolate-scope" alt="" [appAssetSrc]="'assets/images/signature-step2.svg'" />
                        </div>
                    </span>
                    <span class="signature-steps--element signature-steps--elementText signature-steps--element-padding">
                        <div class="signature-steps--content" data-number="2">
                            <span class="signature-steps--text">{{ 'finalisation.content2.ecretement.step2' | i18n }}</span>
                        </div>
                    </span>
                </div>

                <div class="signature-steps--item">
                    <span class="signature-steps--element signature-steps--elementImage">
                        <div class="signature-steps--circle">
                            <img class="signature-steps--image ng-isolate-scope" alt="" [appAssetSrc]="'assets/images/signature-step3.svg'" />
                        </div>
                    </span>
                    <span class="signature-steps--element signature-steps--elementText signature-steps--element-padding">
                        <div class="signature-steps--content" data-number="3">
                            <span class="signature-steps--text">
                                {{ 'finalisation.content2.ecretement.step3' | i18n }}
                            </span>
                        </div>
                    </span>
                </div>

                <div class="signature-steps--item">
                    <span class="signature-steps--element signature-steps--elementImage">
                        <div class="signature-steps--circle">
                            <img class="signature-steps--image" alt="" [appAssetSrc]="'assets/images/signature-step4.svg'" />
                        </div>
                    </span>
                    <span class="signature-steps--element signature-steps--elementText signature-steps--element-padding">
                        <div class="signature-steps--content" data-number="4">
                            <span class="signature-steps--text">
                                {{ 'finalisation.content2.ecretement.step4' | i18n }}
                                <span class="signature-steps--textContact" [innerHTML]="'finalisation.content2.ecretement.step4.contact' | i18n"> </span>
                            </span>
                        </div>
                    </span>
                </div>

                <div class="signature-steps--item">
                    <span class="signature-steps--element signature-steps--elementImage">
                        <div class="signature-steps--circle">
                            <img class="signature-steps--image ng-isolate-scope" alt="" [appAssetSrc]="'assets/images/signature-step5.svg'" />
                        </div>
                    </span>
                    <span class="signature-steps--element signature-steps--elementText signature-steps--element-padding">
                        <div class="signature-steps--content" data-number="5">
                            <span class="signature-steps--text">
                                {{ 'finalisation.content2.ecretement.step5' | i18n }}
                            </span>
                        </div>
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div class="grid-mobile-4 centered">
        <div class="finalisation__information--title">
            {{ 'finalisation.ecretement.information.title' | i18n }}
        </div>
        <div class="finalisation__information--content">
            <div class="finalisation__information--content__paraph">
                {{ 'finalisation.ecretement.information.paraph1' | i18n }}
            </div>
            <div class="finalisation__information--content__paraph">
                {{ 'finalisation.ecretement.information.paraph2' | i18n }}
            </div>
            <div class="finalisation__information--content__paraph">
                {{ finalisationEcretementInfo | i18n }}
            </div>
        </div>
    </div>
</div>

<div class="finalisation__information--correspondant-aeres grid-mobile-6 centered">
    <table class="finalisation__information--correspondant-aeres--table" data-ng-if="finalisation.typeCorrespondantAeras == 'gris' || finalisation.typeCorrespondantAeras == 'vert'">
        <caption style="display: none">
            Aeras table
        </caption>
        <tr>
            <th style="display: none" scope="col">left box</th>
            <th style="display: none" scope="col">middle box</th>
            <th style="display: none" scope="col">right box</th>
        </tr>
        <tr>
            <td class="finalisation__information--correspondant-aeres--table--td">
                <div class="finalisation__information--correspondant-aeres-{{ areasCorrespondType }}--boxleft">
                    <span>{{ areasCorrespondNumero }}</span>
                </div>
            </td>
            <td class="finalisation__information--correspondant-aeres-{{ areasCorrespondType }}--boxmiddle"></td>
            <td class="finalisation__information--correspondant-aeres--table--td">
                <div class="finalisation__information--correspondant-aeres-{{ areasCorrespondType }}--boxright"></div>
            </td>
        </tr>
    </table>
</div>
